export class SubscriberChurnModel {
    month: string = ""
    new: number = 0
    canceled: number = 0
    balance: number = 0
    churn: number = 0
    payers: number = 0

    constructor(s?:Partial<SubscriberChurnModel>) {
        Object.assign(this, s)
    }
}
